import React from "react";
import PaperCheckModal from "./paperCheckModal";
import {PaymentDetails} from "./PaymentDetailsContainer";

const PaperCheckInstructionsModal = ({strings}) => {
    const {paperCheckInstructionsVisibility, hidePaperCheckInstructions} = PaymentDetails.useContainer();
    return <PaperCheckModal strings={strings}
                            size="tiny"
                            onClose={hidePaperCheckInstructions}
                            open={paperCheckInstructionsVisibility} />;
}

export default PaperCheckInstructionsModal;
